import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/CSE507end21.pdf'

export default function OsLab() {
  return (
    <div>
       <Subject title="Operating System Lab(CSE507)" sub="OS Lab" syllabus="#"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}